var map = {
	"./basketball.webp": 1651,
	"./bti-img.webp": 1652,
	"./bti-title-en.webp": 1653,
	"./cup.webp": 1654,
	"./football.webp": 1655,
	"./im-img.webp": 1656,
	"./im-title-en.webp": 1657,
	"./imone-img.webp": 1658,
	"./imone-title-en.webp": 1659,
	"./sb-img.webp": 1660,
	"./sb-title-cn.webp": 1661,
	"./sb-title-en.webp": 1662,
	"./sbo-img.webp": 1663,
	"./sbo-title-cn.webp": 1664,
	"./sbo-title-en.webp": 1665,
	"./sport-bg.webp": 1666,
	"./sport-ctg.webp": 1667,
	"./title-cn.webp": 1668,
	"./title-en.webp": 1669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;